import { LanguageCode } from '@osmosis/shared/languages';

const languageCodes = Object.values(LanguageCode);

/**
 * Get a URL object for the current route.
 */
export const getUrl = () => {
  const url = new URL(window.location.href);
  return url;
};

/**
 * Get language code from url path.
 * @returns Language code from url path.
 */
export const getUrlLanguagePath = (): string => {
  if (typeof window === 'undefined') return '';
  const url = new URL(window.location.href);
  const { pathname } = url;
  const pathParts = pathname.split('/');
  const language = pathParts.find((part) =>
    languageCodes.some((code) => code === part),
  );
  return language || '';
};
